webpackJsonp([1],{

/***/ "+HYR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+YyA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+hCE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    img: String,
    go: [String, Number]
  },
  methods: {
    clickGo: function clickGo() {
      this.$emit('click', this.go);
    }
  }
});

/***/ }),

/***/ "/AoW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0lKk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sr_content_vue__ = __webpack_require__("BJ5h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_1ec29d19_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sr_content_vue__ = __webpack_require__("7X20");
function injectStyle (ssrContext) {
  __webpack_require__("bz1g")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ec29d19"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sr_content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_1ec29d19_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sr_content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_axios__ = __webpack_require__("gKxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_filter__ = __webpack_require__("xU/a");



var utils = function utils() {
  __WEBPACK_IMPORTED_MODULE_0__config_axios__["a" /* default */].init();
  __WEBPACK_IMPORTED_MODULE_1__config_filter__["a" /* default */].init();
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ "111D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1EF+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1LvP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sr--list-container"},[_c('ul',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1bjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_nav_vue__ = __webpack_require__("mKTO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0fd779c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_nav_vue__ = __webpack_require__("AMfi");
function injectStyle (ssrContext) {
  __webpack_require__("9Fq4")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fd779c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0fd779c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "23I9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2rce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_top__ = __webpack_require__("N8YT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav__ = __webpack_require__("1bjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_QRCode__ = __webpack_require__("nBfW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrNavTop: __WEBPACK_IMPORTED_MODULE_0__nav_top__["a" /* default */],
    SrNav: __WEBPACK_IMPORTED_MODULE_1__nav__["a" /* default */],
    SrQrCode: __WEBPACK_IMPORTED_MODULE_2__components_QRCode__["a" /* default */]
  },
  data: function data() {
    return {
      logo: './static/img/logo.png',
      dialogVisible: false,
      qrCodeText: 'http://weixin.qq.com/r/eDjA2OLE_b_Graa7921q',
      isFxid: false,
      top: 0,
      scroll: 0,
      scrollFlag: true
    };
  },

  methods: {
    goIndex: function goIndex() {
      this.$router.push('/index');
    },
    signUser: function signUser() {
      this.dialogVisible = true;
    },
    getTop: function getTop() {
      this.top = this.$refs.nav.offsetTop;
    },
    toScroll: function toScroll() {
      var _this = this;

      if (this.scrollFlag) {
        this.scrollFlag = !this.scrollFlag;
        setTimeout(function () {
          _this.scroll = document.body.scrollTop || document.documentElement.scrollTop;
          if (_this.scroll >= _this.top) {
            _this.isFxid = true;
          } else {
            _this.isFxid = false;
          }
          _this.scrollFlag = !_this.scrollFlag;
        }, 60);
      }
    }
  },
  mounted: function mounted() {
    this.getTop();
    window.addEventListener('scroll', this.toScroll);
  }
});

/***/ }),

/***/ "2vSh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sr_top_vue__ = __webpack_require__("Zkul");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2715be10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sr_top_vue__ = __webpack_require__("Dtrx");
function injectStyle (ssrContext) {
  __webpack_require__("fl/p")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2715be10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sr_top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2715be10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sr_top_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3G5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{class:[{'header-fixed-true': _vm.isFxid}, 'header-fixed']},[_c('div',{staticClass:"cover"},[_c('ul',{staticClass:"sign-user"},[_c('li',[_c('span',{on:{"click":_vm.signUser}},[_vm._v("注册")])]),_vm._v(" "),_c('li',[_c('span',{on:{"click":_vm.signUser}},[_vm._v("登录")])])]),_vm._v(" "),_c('div',{staticClass:"logo",style:({backgroundImage: 'url(' + _vm.logo + ')'}),on:{"click":_vm.goIndex}})]),_vm._v(" "),_c('div',{ref:"nav",staticClass:"nav"},[_c('sr-nav-top',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFxid),expression:"isFxid"}],on:{"click":_vm.signUser}}),_vm._v(" "),_c('sr-nav')],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"300px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"sign-user-con"},[_c('p',[_vm._v("请扫码关注公众号")]),_vm._v(" "),_c('p',[_vm._v("进入耀莱微信官网进行操作")]),_vm._v(" "),_c('sr-qr-code',{attrs:{"text":_vm.qrCodeText}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4bqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("aI55");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_317aad47_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("jjER");
function injectStyle (ssrContext) {
  __webpack_require__("fjOd")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-317aad47"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_317aad47_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4qJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[(_vm.loading)?_c('sr-loading'):_c('div',[_c('div',{staticClass:"tab"},[_c('el-radio-group',{attrs:{"size":"small"},on:{"change":_vm.tabChange},model:{value:(_vm.queryForm.baseType),callback:function ($$v) {_vm.$set(_vm.queryForm, "baseType", $$v)},expression:"queryForm.baseType"}},_vm._l((_vm.tabData),function(item){return _c('el-radio-button',{key:item.label,attrs:{"label":item.label}},[_vm._v(_vm._s(item.text))])}),1)],1),_vm._v(" "),_c('sr-list',_vm._l((_vm.listData),function(item,index){return _c('sr-list-item',{key:index,attrs:{"img":item.defaultImage,"go":item.uuid},on:{"click":_vm.go}},[_c('div',{staticClass:"sr-list-txt"},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(item.brandNameEn)+" / "+_vm._s(item.brandName))]),_vm._v(" "),_c('p',{staticClass:"p2",attrs:{"title":item.name}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"p3"},[_vm._v(_vm._s(_vm._f("money")(item.currentPrice)))]),_vm._v(" "),_c('p',{staticClass:"p4"},[_vm._v(_vm._s(_vm._f("money")(item.basicPrice)))])])])}),1),_vm._v(" "),(_vm.total > 0)?_c('div',{staticClass:"page"},[_c('el-pagination',{attrs:{"current-page":_vm.queryForm.pageNum,"page-size":_vm.queryForm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4ue7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"travel"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"header_qrcode"},[_c('sr-qr-code',{attrs:{"text":_vm.qrCodeText}}),_vm._v(" "),_c('p',{staticClass:"t"},[_vm._v("扫一扫，立即预订机场服务")])],1),_vm._v(" "),_c('div',{staticClass:"header_img"},[_c('p',{staticClass:"img",style:({backgroundImage: 'url(' + _vm.ad.img + ')'})}),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.ad.title))])])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h3',[_vm._v("业务")]),_vm._v(" "),_c('p',[_vm._v("公司主营业务包括国内/国际机票预订、国际出行、公务机预订、家门到机舱门的全程高端服务、安保服务和车辆租赁。我们的服务关注您的每一个细节，从您的家门口到机舱门口全程都有专业人员为您服务，机场不论您是国内出行，国际出行，国内转机，国际转机，还是航班延误，航班取消，我们都会专人贴心为您服务，让您的每次出行都安心，贴心，愉快。")]),_vm._v(" "),_c('p',[_vm._v("依托集团的高端市场资源，与众多千亿资产企业，及影视明星等达成深度合作，已成为名企指定高端团组出行、接待与服务的最佳机构。")]),_vm._v(" "),_c('p',[_vm._v("机场部，高水平服务始终贯穿整个流程：机场设立贵宾迎送部门，贵宾在到达机场后，可享受vip服务的待遇,(登机牌办理.行李托运.专用停车场.专用休息室.独立安检通道.以及私人机下摆渡车等)。")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("联系方式（北京）")]),_vm._v(" "),_c('p',[_vm._v("票务中心： 400 634 0777")]),_vm._v(" "),_c('p',[_vm._v("机场处电话：（010）81466718")]),_vm._v(" "),_c('p',[_vm._v("总部电话： 86-10-81466165")]),_vm._v(" "),_c('p',[_vm._v("网址：www.ylzxvip.com")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "50p+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"car"},[_c('sr-list',_vm._l((_vm.DATA),function(item,index){return _c('sr-list-item',{key:index,attrs:{"img":item.img,"go":item.href},on:{"click":_vm.go}},[_c('div',{staticClass:"sr-list-txt"},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(item.brand))]),_vm._v(" "),_c('p',{staticClass:"p2",attrs:{"title":item.name}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"p3"},[_vm._v(_vm._s(_vm._f("money")(item.price)))]),_vm._v(" "),_c('p',{staticClass:"p4"},[_vm._v(_vm._s(_vm._f("money")(item.priceOriginal)))])])])}),1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"300px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("微信扫一扫")]),_vm._v(" "),_c('p',[_vm._v("了解更多精彩信息，在线预约看车")]),_vm._v(" "),_c('sr-qr-code',{attrs:{"text":_vm.qrCodeText}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5AIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"sr--li"},[_c('div',{staticClass:"sr--li_box",on:{"click":_vm.clickGo}},[_c('p',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.img),expression:"img",arg:"background-image"}],staticClass:"sr--li_img"}),_vm._v(" "),_c('div',{staticClass:"sr--li_container"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5k0U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.DATA.productSpuAttribute.length > 0)?_c('div',{staticClass:"param"},[_c('div',{staticClass:"name"},[_vm._v("· 基本参数 ·")]),_vm._v(" "),_c('ul',{staticClass:"list"},_vm._l((_vm.DATA.productSpuAttribute),function(item){return _c('li',[_c('p',{attrs:{"title":item.attribute + '：' + item.attributeValue}},[_vm._v(_vm._s(item.attribute)+"："+_vm._s(item.attributeValue))])])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7X20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"name"},[_vm._v("· 餐厅特色 ·")]),_vm._v(" "),_c('div',{staticClass:"sr-text"},[_c('div',{staticClass:"sr-con",domProps:{"innerHTML":_vm._s(_vm.DATA.info.shopDescription)}})])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"name"},[_vm._v("· 推荐菜品 ·")]),_vm._v(" "),_c('div',{staticClass:"sr-list"},[_c('ul',_vm._l((_vm.DATA.info.recommendDishes),function(item){return _c('li',[_c('div',{staticClass:"box"},[_c('p',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.imgUrl + item.path),expression:"imgUrl + item.path",arg:"background-image"}],staticClass:"img"}),_vm._v(" "),(item.description)?_c('p',{staticClass:"title"},[_vm._v(_vm._s(item.description))]):_vm._e()])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9DsB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Fq4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9qt5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header__ = __webpack_require__("JCuE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer__ = __webpack_require__("Bnh8");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrHeader: __WEBPACK_IMPORTED_MODULE_1__components_header__["a" /* default */],
    SrFooter: __WEBPACK_IMPORTED_MODULE_2__components_footer__["a" /* default */]
  },
  data: function data() {
    return {
      viewFlag: false
    };
  },

  methods: {
    getImgUrl: function getImgUrl() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/product/findImgUrl').then(function (res) {
        if (res.data.code === 9999) {
          _this.$store.state.imgUrl = res.data.data;
          _this.viewFlag = true;
        }
      });
    }
  },
  created: function created() {
    this.getImgUrl();
  }
});

/***/ }),

/***/ "AI09":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AMfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"sr-nav"},[_c('ul',{staticClass:"ul"},_vm._l((_vm.navData),function(item){return _c('li',[_c('span',{class:[{'is-link': item.isLink}, 'link'],on:{"mouseenter":function($event){return _vm.navMouseover(item)},"mouseleave":_vm.navMouseout,"click":function($event){return _vm.goMenu(item.href)}}},[_vm._v(_vm._s(item.name))])])}),0),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"dropdown-menu",on:{"mouseenter":_vm.navMouseovers,"mouseleave":_vm.navMouseout}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"list"},[_vm._l((_vm.menuData),function(item,index){return [(index < 4)?_c('dl',{style:({width: item.width ? item.width : ''})},[_c('dt',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_vm._l((item.children),function(i){return _c('dd',[(i.linkType === 0)?_c('span',{on:{"click":function($event){return _vm.goList(i.linkType, i.wechatProductCategories)}}},[_vm._v(_vm._s(i.name))]):_vm._e(),_vm._v(" "),(i.linkType === 1)?_c('span',{on:{"click":function($event){return _vm.goList(i.linkType, i.wechatLinkUrl)}}},[_vm._v(_vm._s(i.name))]):_vm._e(),_vm._v(" "),(i.linkType === 'restaurant')?_c('span',{on:{"click":function($event){return _vm.goList(i.linkType, i.href)}}},[_vm._v(_vm._s(i.name))]):_vm._e()])})],2):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"ad-container"},[_c('sr-ad',{attrs:{"ad":_vm.ad}})],1)])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fadeS"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"wool-glass"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BJ5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: Object
  },
  data: function data() {
    return {
      imgUrl: this.$store.state.imgUrl,
      DATA: this.data
    };
  }
});

/***/ }),

/***/ "BQse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ITgx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_33ddc89f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("h7Y1");
function injectStyle (ssrContext) {
  __webpack_require__("Mb9h")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33ddc89f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_33ddc89f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BYI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" 加载中...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bnh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("CriK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f3fdd242_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("u1WI");
function injectStyle (ssrContext) {
  __webpack_require__("111D")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3fdd242"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f3fdd242_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CriK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_QRCode__ = __webpack_require__("nBfW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrQrCode: __WEBPACK_IMPORTED_MODULE_0__components_QRCode__["a" /* default */]
  },
  data: function data() {
    return {
      qrCodeSize: 120,
      qrCodeSR: 'http://weixin.qq.com/r/eDjA2OLE_b_Graa7921q',
      qrCodeBusiness: 'http://weixin.qq.com/r/jjlIUNLEDo9xrZYz92yc'
    };
  }
});

/***/ }),

/***/ "Dtrx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sr-property"},[_c('div',{staticClass:"gallery"},[_c('sr-thumb-zoom',{attrs:{"list":_vm.DATA.info.shopImages}})],1),_vm._v(" "),_c('div',{staticClass:"wrap"},[_c('p',{staticClass:"shopName"},[_vm._v(_vm._s(_vm.DATA.info.shopName))]),_vm._v(" "),_c('p',{staticClass:"avgCount"},[_c('span',[_vm._v(_vm._s(_vm._f("money")(_vm.DATA.info.avgCount)))]),_vm._v(" / 人均")]),_vm._v(" "),_c('p',{staticClass:"address"},[_vm._v("地址："+_vm._s(_vm.DATA.info.address))]),_vm._v(" "),_c('p',{staticClass:"reservationCall"},[_vm._v("电话："+_vm._s(_vm.DATA.info.reservationCall))]),_vm._v(" "),_c('p',{staticClass:"storeInfo"},[_vm._v("简介："+_vm._s(_vm.DATA.info.storeInfo))]),_vm._v(" "),(_vm.DATA.info.reminder)?_c('div',{staticClass:"reminder"},[_c('p',[_vm._v("温馨提示：")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.DATA.info.reminder)}})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EcCA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("cfAk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7a408179_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("lpeH");
function injectStyle (ssrContext) {
  __webpack_require__("U82w")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a408179"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7a408179_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HOoM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"QRCode",style:(_vm.styleObject)},[_c('img',{attrs:{"src":_vm.srcBase64}}),_vm._v(" "),_c('p')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I5X4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sr_top_vue__ = __webpack_require__("m/91");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7e41aa51_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sr_top_vue__ = __webpack_require__("wTL7");
function injectStyle (ssrContext) {
  __webpack_require__("1EF+")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e41aa51"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sr_top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7e41aa51_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sr_top_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ITgx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sr_top__ = __webpack_require__("2vSh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sr_content__ = __webpack_require__("0lKk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_loading__ = __webpack_require__("qERK");
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrTop: __WEBPACK_IMPORTED_MODULE_1__sr_top__["a" /* default */],
    SrContent: __WEBPACK_IMPORTED_MODULE_2__sr_content__["a" /* default */],
    SrLoading: __WEBPACK_IMPORTED_MODULE_3__components_loading__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      DATA: {}
    };
  },

  methods: {
    getInfo: function getInfo() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/node/api/restaurant/info', {
        storeId: this.$route.params.id,
        spotX: 38.8,
        spotY: 116
      }).then(function (res) {
        if (res.data.code === 9999) {
          _this.DATA = res.data;
          _this.loading = false;
          document.title = _this.DATA.info.shopName + ' - 耀莱在线';
        }
      });
    }
  },
  created: function created() {
    this.getInfo();
  },

  watch: {
    '$route': function $route() {
      this.getInfo();
    }
  }
});

/***/ }),

/***/ "IUvc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("nhZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("bSIt");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* 项目全局State */
var state = {
  imgUrl: ''

  /* Store实例 */
};/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state
}));

/***/ }),

/***/ "JCuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("2rce");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_56c132f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("3G5R");
function injectStyle (ssrContext) {
  __webpack_require__("23I9")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56c132f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_56c132f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jktd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LWDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ul',{staticClass:"tab"},_vm._l((_vm.tab),function(item){return _c('li',[_c('p',{class:[item.flag ? 'cur' : ''],on:{"click":function($event){return _vm.toggle(item)}}},[_vm._v(_vm._s(item.name))])])}),0),_vm._v(" "),_c('div',{staticClass:"sr-text"},[_vm._l((_vm.tab),function(item){return [_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.flag),expression:"item.flag"}],staticClass:"sr-con",domProps:{"innerHTML":_vm._s(_vm.DATA[item.text])}})]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3c3346ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("o2Or");
function injectStyle (ssrContext) {
  __webpack_require__("/AoW")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3c3346ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mb9h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mvvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sr_content_vue__ = __webpack_require__("PvwS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d0e7c446_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sr_content_vue__ = __webpack_require__("LWDO");
function injectStyle (ssrContext) {
  __webpack_require__("lqD4")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0e7c446"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sr_content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d0e7c446_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sr_content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N8YT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_nav_top_vue__ = __webpack_require__("Vs0J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3d9f6bea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_nav_top_vue__ = __webpack_require__("odf5");
function injectStyle (ssrContext) {
  __webpack_require__("leB2")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d9f6bea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_nav_top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3d9f6bea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_nav_top_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("nhZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store___ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__("t6lK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_element_ui__ = __webpack_require__("av4O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("0xDb");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__utils_element_ui__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */]
});

/***/ }),

/***/ "NaQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    ad: [String, Number]
  },
  data: function data() {
    return {
      list: {
        '331': {
          title: '服饰',
          img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/07ca671d-c91f-43df-a617-e4c94456a531.jpg'
        },
        '341': {
          title: '醇酿',
          img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/87e105d3-61d1-4af8-a97c-be03acba833b.jpg'
        },
        '361': {
          title: '奢品',
          img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/ebbbbdb3-6daf-41f6-b301-2f5f15405c9c.jpg'
        },
        '1172': {
          title: '美妆',
          img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/e3de6243-e65b-48b7-a28d-e2b69d823ebd.jpg'
        },
        'canyin': {
          title: '餐饮',
          img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/fbef135f-80d9-40dd-a0ea-960081717af6.jpg'
        }
      }
    };
  }
});

/***/ }),

/***/ "NhaM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NrSp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("s2Ez");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4f53ae89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("qkT3");
function injectStyle (ssrContext) {
  __webpack_require__("NhaM")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f53ae89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4f53ae89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OQkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad"},[(_vm.list[_vm.ad])?[_c('p',{staticClass:"img",style:({backgroundImage: 'url(' + _vm.list[_vm.ad].img + ')'})}),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.list[_vm.ad].title))])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PvwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: Object
  },
  data: function data() {
    return {
      DATA: this.data,
      tab: [{
        flag: true,
        name: '产品介绍',
        text: 'productDescLong'
      }, {
        flag: false,
        name: '品牌故事',
        text: 'productStory'
      }]
    };
  },

  methods: {
    toggle: function toggle(v) {
      this.tab.forEach(function (arr) {
        arr.flag = false;
      });
      v.flag = true;
    }
  }
});

/***/ }),

/***/ "Q5JW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},_vm._l((_vm.list),function(item){return _c('a',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(item.img),expression:"item.img",arg:"background-image"}],staticClass:"img",style:({backgroundColor: item.color}),attrs:{"href":item.link,"target":"_blank"}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qt9A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("oT9R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_48de7190_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Q5JW");
function injectStyle (ssrContext) {
  __webpack_require__("IUvc")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48de7190"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_48de7190_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R1v2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ZNWw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6ae0dd92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4ue7");
function injectStyle (ssrContext) {
  __webpack_require__("AI09")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ae0dd92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6ae0dd92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TOte":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TzAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_list__ = __webpack_require__("hXc6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_list_item__ = __webpack_require__("b/+Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_QRCode__ = __webpack_require__("nBfW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    srList: __WEBPACK_IMPORTED_MODULE_0__components_list__["a" /* default */],
    srListItem: __WEBPACK_IMPORTED_MODULE_1__components_list_item__["a" /* default */],
    SrQrCode: __WEBPACK_IMPORTED_MODULE_2__components_QRCode__["a" /* default */]
  },
  data: function data() {
    return {
      DATA: [{
        img: '//yaolai-img.oss-cn-beijing.aliyuncs.com/group1/M00/00/7F/CgoJFFhJK2aAUvrbAADJFOeyhpU980.jpg',
        brand: 'BENTLEY / 宾利',
        name: '慕尚 2017款 6.75T 黑色 现车',
        price: '6548000',
        priceOriginal: '6548000',
        href: 'https://m2.ylzxvip.com/limousine/#/details/motion?1=1&classify=' + encodeURIComponent('宾利幕尚')
      }, {
        img: '//yaolai-img.oss-cn-beijing.aliyuncs.com/group1/M00/00/80/CgoJFFhJMwOAMGvlAACWW-y3GkU048.jpg',
        brand: 'BENTLEY / 宾利',
        name: '飞驰 V8 4.0T 四座 现车',
        price: '3598000',
        priceOriginal: '3598000',
        href: 'https://m2.ylzxvip.com/limousine/#/details/fly?1=1&classify=' + encodeURIComponent('宾利飞驰')
      }, {
        img: '//yaolai-img.oss-cn-beijing.aliyuncs.com/group1/M00/00/9F/CgoJFFh1m1KAdpbsAAFxbvIhITE384.jpg',
        brand: 'BENTLEY / 宾利',
        name: '添越 2017款SUV 6.0T 现车',
        price: '4798000',
        priceOriginal: '4798000',
        href: 'https://m2.ylzxvip.com/limousine/#/details/bentayga?1=1&classify=' + encodeURIComponent('宾利添越')
      }, {
        img: '//yaolai-img.oss-cn-beijing.aliyuncs.com/group1/M00/00/84/CgoJFFhKKsaAPPMvAACwVdMyFTk969.jpg',
        brand: 'BENTLEY / 宾利',
        name: '欧陆GT V8 2016款 4.0T 四座 现车',
        price: '3108000',
        priceOriginal: '3108000',
        href: 'https://m2.ylzxvip.com/limousine/#/details/GT?1=1&classify=' + encodeURIComponent('宾利欧陆GT')
      }],
      dialogVisible: false,
      qrCodeText: ''
    };
  },

  methods: {
    go: function go(v) {
      this.qrCodeText = v;
      this.dialogVisible = true;
    }
  }
});

/***/ }),

/***/ "U82w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V3SK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VriL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vs0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__("1bjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_QRCode__ = __webpack_require__("nBfW");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrNav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */],
    SrQrCode: __WEBPACK_IMPORTED_MODULE_1__components_QRCode__["a" /* default */]
  },
  data: function data() {
    return {
      logo: './static/img/logomin.png'
    };
  },

  methods: {
    goIndex: function goIndex() {
      this.$router.push('/index');
    },
    signUser: function signUser() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ "XAoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode__ = __webpack_require__("2rQN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcode__);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: String,
    size: Number
  },
  data: function data() {
    return {
      srcBase64: '',
      styleObject: {
        width: this.size + 'px',
        height: this.size + 'px'
      }
    };
  },

  methods: {
    getQRCode: function getQRCode() {
      var _this = this;

      var opts = {
        errorCorrectionLevel: 'H',
        type: 'image/png',
        scale: 6
      };
      __WEBPACK_IMPORTED_MODULE_0_qrcode___default.a.toDataURL(this.text, opts, function (err, url) {
        if (err) throw err;
        _this.srcBase64 = url;
      });
    }
  },
  created: function created() {
    this.getQRCode();
  },

  watch: {
    'text': function text() {
      this.getQRCode();
    }
  }
});

/***/ }),

/***/ "XLeV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YLOT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.viewFlag)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_c('sr-header'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('sr-footer')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("nhZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("cigS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_main__ = __webpack_require__("uUni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_index_index__ = __webpack_require__("Qt9A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_list__ = __webpack_require__("bfEA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_list_detail__ = __webpack_require__("EcCA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_restaurant__ = __webpack_require__("NrSp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_restaurant_detail__ = __webpack_require__("BQse");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_car__ = __webpack_require__("npy4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_travel__ = __webpack_require__("R1v2");











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/main',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_main__["a" /* default */],
    meta: { title: '耀莱在线' },
    redirect: '/index',
    children: [{
      path: '/index',
      name: 'Index',
      meta: { title: '首页' },
      component: __WEBPACK_IMPORTED_MODULE_3__pages_index_index__["a" /* default */]
    }, {
      path: '/list/:type',
      name: 'list',
      meta: { title: '商品列表' },
      component: __WEBPACK_IMPORTED_MODULE_4__pages_list__["a" /* default */]
    }, {
      path: '/list-detail/:id',
      name: 'listDetail',
      component: __WEBPACK_IMPORTED_MODULE_5__pages_list_detail__["a" /* default */],
      meta: { title: '商品详情' }
    }, {
      path: '/restaurant',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_restaurant__["a" /* default */],
      meta: { title: '餐厅列表' }
    }, {
      path: '/restaurant-detail/:id',
      component: __WEBPACK_IMPORTED_MODULE_7__pages_restaurant_detail__["a" /* default */],
      meta: { title: '餐厅详情' }
    }, {
      path: '/car',
      component: __WEBPACK_IMPORTED_MODULE_8__pages_car__["a" /* default */],
      meta: { title: '豪车' }
    }, {
      path: '/travel',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_travel__["a" /* default */],
      meta: { title: '出行' }
    }]
  }, { path: '*', redirect: '/main' }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(function (to, from, next) {
  document.title = to.meta.title + ' - 耀莱在线';
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZNWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_QRCode__ = __webpack_require__("nBfW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrQrCode: __WEBPACK_IMPORTED_MODULE_0__components_QRCode__["a" /* default */]
  },
  data: function data() {
    return {
      ad: {
        title: '出行',
        img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/5e579dae-9367-4aa0-8395-4a5f2700a6e1.jpg'
      },
      qrCodeText: 'https://m2.ylzxvip.com/reception/#/air-index'
    };
  }
});

/***/ }),

/***/ "Zkul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_thumb_zoom__ = __webpack_require__("4bqQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrThumbZoom: __WEBPACK_IMPORTED_MODULE_0__components_thumb_zoom__["a" /* default */]
  },
  props: {
    data: Object
  },
  data: function data() {
    return {
      DATA: this.data
    };
  }
});

/***/ }),

/***/ "aB1h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aI55":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: Array,
    path: Boolean
  },
  data: function data() {
    return {
      DATA: this.list,
      thumb: []
    };
  },

  methods: {
    isThumb: function isThumb() {
      var _this = this;

      if (this.DATA) {
        this.DATA.forEach(function (arr, index) {
          _this.thumb.push({
            flag: index === 0 ? 'true' : '',
            src: _this.path ? _this.$store.state.imgUrl + arr : arr
          });
        });
      }
    },
    toggleImg: function toggleImg(v) {
      this.thumb.forEach(function (arr) {
        arr.flag = '';
      });
      v.flag = 'true';
    }
  },
  created: function created() {
    this.isThumb();
  }
});

/***/ }),

/***/ "av4O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_radio_button_css__ = __webpack_require__("pWly");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_radio_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_radio_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("9DsB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_radio_button__ = __webpack_require__("qbwY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_radio_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_radio_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_radio_group_css__ = __webpack_require__("fkgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_radio_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_radio_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group__ = __webpack_require__("mRgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("+YyA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination__ = __webpack_require__("FlmH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("V3SK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog__ = __webpack_require__("+zHG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("XLeV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_loading__ = __webpack_require__("7nJo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("nhZ1");


















var elementui = function elementui() {
  __WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_loading___default.a);
  __WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog___default.a);
  __WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination___default.a);
  __WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group___default.a);
  __WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_radio_button___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (elementui);

/***/ }),

/***/ "b/+Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_vue__ = __webpack_require__("+hCE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4cee4613_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_item_vue__ = __webpack_require__("5AIS");
function injectStyle (ssrContext) {
  __webpack_require__("aB1h")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cee4613"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4cee4613_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bfEA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("yt9w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0a1e1d20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4qJq");
function injectStyle (ssrContext) {
  __webpack_require__("pX7/")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a1e1d20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0a1e1d20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bz1g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cfAk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sr_top__ = __webpack_require__("I5X4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sr_param__ = __webpack_require__("zS9/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sr_content__ = __webpack_require__("Mvvo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_loading__ = __webpack_require__("qERK");
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrTop: __WEBPACK_IMPORTED_MODULE_1__sr_top__["a" /* default */],
    SrParam: __WEBPACK_IMPORTED_MODULE_2__sr_param__["a" /* default */],
    SrContent: __WEBPACK_IMPORTED_MODULE_3__sr_content__["a" /* default */],
    SrLoading: __WEBPACK_IMPORTED_MODULE_4__components_loading__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      DATA: {}
    };
  },

  methods: {
    selectByUUid: function selectByUUid() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/productSpuController/selectByUUid', {
        params: {
          id: this.$route.params.id
        }
      }).then(function (res) {
        if (res.data.code === 9999) {
          _this.DATA = res.data.data;
          _this.loading = false;
          document.title = _this.DATA.name + ' - 耀莱在线';
        }
      });
    }
  },
  created: function created() {
    this.selectByUUid();
  }
});

/***/ }),

/***/ "fjOd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fkgV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fl/p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gKxt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__("cp3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);





/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.request.use(function (config) {
      if (config.method === 'post') {
        config.data = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(config.data);
      } else if (config.method === 'get') {
        config.params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config.params);
      }
      return config;
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    // http response 拦截器
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(function (response) {
      switch (response.data.code) {
        case 9999:
          break;
        default:
          alert(response.data.msg.context);
      }
      return response;
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),

/***/ "gjYz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h7Y1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[(_vm.loading)?_c('sr-loading'):_c('div',[_c('sr-top',{attrs:{"data":_vm.DATA}}),_vm._v(" "),_c('sr-content',{attrs:{"data":_vm.DATA}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hXc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_335f9cec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("1LvP");
function injectStyle (ssrContext) {
  __webpack_require__("VriL")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_335f9cec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i6xC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jjER":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumb-zoom"},[_c('ul',{staticClass:"thumb"},_vm._l((_vm.thumb),function(item,index){return (index < 3)?_c('li',{class:[item.flag === 'true' ? 'cur' : ''],on:{"click":function($event){return _vm.toggleImg(item)}}},[_c('p',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(item.src),expression:"item.src",arg:"background-image"}]})]):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"thumbZoom"},[_vm._l((_vm.thumb),function(item){return (item.flag === 'true')?[_c('img',{attrs:{"src":item.src}})]:_vm._e()})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "leB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lpeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[(_vm.loading)?_c('sr-loading'):_c('div',[_c('sr-top',{attrs:{"data":_vm.DATA}}),_vm._v(" "),_c('sr-param',{attrs:{"data":_vm.DATA}}),_vm._v(" "),_c('sr-content',{attrs:{"data":_vm.DATA}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqD4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m/91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_thumb_zoom__ = __webpack_require__("4bqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_QRCode__ = __webpack_require__("nBfW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrThumbZoom: __WEBPACK_IMPORTED_MODULE_0__components_thumb_zoom__["a" /* default */],
    SrQrCode: __WEBPACK_IMPORTED_MODULE_1__components_QRCode__["a" /* default */]
  },
  props: {
    data: Object
  },
  data: function data() {
    return {
      DATA: this.data,
      thumb: [],
      dialogVisible: false,
      qrCodeText: ''
    };
  },

  methods: {
    buy: function buy(v) {
      this.dialogVisible = true;
      this.qrCodeText = 'https://m2.ylzxvip.com/luxury/#/luxury-goods-detail/' + v;
    }
  }
});

/***/ }),

/***/ "mKTO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ad__ = __webpack_require__("q+Xb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrAd: __WEBPACK_IMPORTED_MODULE_1__ad__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      navFormat: {
        one: [],
        two: [],
        three: []
      },
      navData: [],
      menuData: [],
      visible: false,
      timeout: null,
      showTimeout: 250,
      hideTimeout: 150,
      ad: ''
    };
  },

  methods: {
    getRestaurant: function getRestaurant() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/node/api/restaurant', {
        pageNum: 1,
        pageSize: 10,
        xCoord: 38.8,
        yCoord: 116
      }).then(function (res) {
        if (res.data.code === 9999) {
          var list = [];
          res.data.data.forEach(function (arr) {
            list.push({
              linkType: 'restaurant',
              name: arr.storeName,
              href: '/restaurant-detail/' + arr.storeSysno
            });
          });
          _this.navData.push({
            isLink: false,
            id: 'canyin',
            name: '餐饮',
            children: [{
              name: '地域',
              children: [{
                linkType: 'restaurant',
                name: '北京',
                href: '/restaurant'
              }]
            }, {
              width: '300px',
              name: '餐厅',
              children: list
            }]
          });
          _this.loading = false;
        }
      });
    },
    getECCategory: function getECCategory() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/ECCategory/getECCategory').then(function (res) {
        if (res.data.code === 9999) {
          res.data.data.categoryList.forEach(function (arr) {
            if (arr.level === 1 && arr.id !== 300 && arr.id !== 351) {
              _this2.navFormat.one.push(arr);
            } else if (arr.level === 2) {
              _this2.navFormat.two.push(arr);
            } else if (arr.level === 3) {
              _this2.navFormat.three.push(arr);
            }
          });
          _this2.levelOne();
          _this2.navData.push({ isLink: false, name: '豪车', href: '/car' }, { isLink: false, name: '出行', href: '/travel' });
          _this2.getRestaurant();
        }
      });
    },
    levelOne: function levelOne() {
      var _this3 = this;

      this.navFormat.one.forEach(function (one, oneIndex) {
        _this3.navData.push({
          isLink: false,
          id: one.id,
          name: one.name,
          children: []
        });
        _this3.levelTwo(one, oneIndex);
      });
    },
    levelTwo: function levelTwo(one, oneIndex) {
      var _this4 = this;

      var twoIndex = 0;
      this.navFormat.two.forEach(function (two) {
        if (one.id === two.parentId) {
          _this4.navData[oneIndex].children.push({
            id: two.id,
            name: two.name,
            children: []
          });
          _this4.levelThree(two, oneIndex, twoIndex);
          twoIndex++;
        }
      });
    },
    levelThree: function levelThree(two, oneIndex, twoIndex) {
      var _this5 = this;

      this.navFormat.three.forEach(function (three) {
        if (two.id === three.parentId) {
          _this5.navData[oneIndex].children[twoIndex].children.push({
            linkType: three.linkType,
            name: three.name,
            wechatProductCategories: three.wechatProductCategories,
            wechatLinkUrl: three.wechatLinkUrl
          });
        }
      });
    },
    navMouseover: function navMouseover(item) {
      var _this6 = this;

      if (item && !item.children) {
        return;
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this6.cleaerLink();
        if (item) {
          item.isLink = true;
        }
        _this6.visible = true;
        _this6.menuData = item.children;
        _this6.ad = item.id;
      }, this.showTimeout);
    },
    navMouseovers: function navMouseovers() {
      this.visible = true;
      clearTimeout(this.timeout);
    },
    navMouseout: function navMouseout(item) {
      var _this7 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this7.cleaerLink();
      }, this.hideTimeout);
    },
    cleaerLink: function cleaerLink() {
      this.navData.forEach(function (arr) {
        arr.isLink = false;
      });
      this.visible = false;
    },
    goList: function goList(type, v) {
      this.visible = false;
      if (type === 0) {
        this.$router.push({
          path: '/list/category',
          query: {
            id: v
          }
        });
      } else if (type === 1) {
        this.$router.push({
          path: '/list/brand',
          query: {
            id: v.split('brandId=')[1]
          }
        });
      } else if (type === 'restaurant') {
        this.$router.push({
          path: v
        });
      }
    },
    goMenu: function goMenu(v) {
      if (v) {
        this.$router.push(v);
      }
    }
  },
  created: function created() {
    this.getECCategory();
  }
});

/***/ }),

/***/ "nBfW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("XAoT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4dd86627_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("HOoM");
function injectStyle (ssrContext) {
  __webpack_require__("Jktd")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dd86627"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4dd86627_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "npy4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("TzAC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_690ba711_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("50p+");
function injectStyle (ssrContext) {
  __webpack_require__("gjYz")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-690ba711"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_690ba711_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o2Or":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oT9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      list: [{
        color: '#7e6d53',
        // link: 'https://mybank.icbc.com.cn/icbc/newperbank/bankbook/bankbook_onlineapply_mid.jsp?firstPage=111&corpCode=HZDW000007461&promoCode=HW88802001587429641',
        // img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2018/03/07/f33ef2a8-8b9e-48f3-a829-5d7a890eb231.jpeg',
        link: 'https://m2.ylzxvip.com/profile?origin=main-pc/#/index/restaurant',
        img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2018/04/25/2d4301be-20f5-42b3-9386-9a957bad93ae.jpg'
      }, {
        color: '#7d502f',
        img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/19a48c3d-d9eb-421c-a772-4a297ec1eddf.jpg'
      }, {
        color: '#293c4b',
        img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/3351ffb8-c8e0-45ef-ad17-d70a80a44ab4.jpg'
      }, {
        color: '#7e6d53',
        img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/6da5fc1b-dc2f-4c96-9956-816580ba7070.jpg'
      }]
    };
  }
});

/***/ }),

/***/ "odf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-top"},[_c('div',{staticClass:"logo",style:({backgroundImage: 'url(' + _vm.logo + ')'}),on:{"click":_vm.goIndex}}),_vm._v(" "),_c('ul',{staticClass:"r"},[_c('li',[_c('span',{on:{"click":_vm.signUser}},[_vm._v("登录")])]),_vm._v(" "),_c('li',[_c('span',{on:{"click":_vm.signUser}},[_vm._v("注册")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pWly":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pX7/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q+Xb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ad_vue__ = __webpack_require__("NaQU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_671d1762_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ad_vue__ = __webpack_require__("OQkG");
function injectStyle (ssrContext) {
  __webpack_require__("+HYR")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-671d1762"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_671d1762_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qERK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3b9ba3a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("BYI/");
function injectStyle (ssrContext) {
  __webpack_require__("z5L2")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b9ba3a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3b9ba3a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qkT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[(_vm.loading)?_c('sr-loading'):_c('sr-list',_vm._l((_vm.listData),function(item,index){return _c('sr-list-item',{key:index,attrs:{"img":item.defaultImage,"go":item.storeSysno},on:{"click":_vm.go}},[_c('div',{staticClass:"sr-list-txt"},[_c('p',{staticClass:"p1",attrs:{"title":item.storeName}},[_vm._v(_vm._s(item.storeName))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v(_vm._s(item.address))]),_vm._v(" "),_c('p',{staticClass:"p3",attrs:{"title":item.detail}},[_vm._v(_vm._s(item.detail))])])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s2Ez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loading__ = __webpack_require__("qERK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_list__ = __webpack_require__("hXc6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_list_item__ = __webpack_require__("b/+Y");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrLoading: __WEBPACK_IMPORTED_MODULE_1__components_loading__["a" /* default */],
    srList: __WEBPACK_IMPORTED_MODULE_2__components_list__["a" /* default */],
    srListItem: __WEBPACK_IMPORTED_MODULE_3__components_list_item__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      listData: []
    };
  },

  methods: {
    restaurant: function restaurant() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/node/api/restaurant', {
        pageNum: 1,
        pageSize: 100,
        xCoord: 38.8,
        yCoord: 116
      }).then(function (res) {
        if (res.data.code === 9999) {
          _this.listData = res.data.data;
          _this.loading = false;
        }
      });
    },
    go: function go(v) {
      this.$router.push({
        path: '/restaurant-detail/' + v
      });
    }
  },
  created: function created() {
    this.restaurant();
  }
});

/***/ }),

/***/ "u1WI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"desc"},[_vm._m(0),_vm._v(" "),_c('dl',{staticClass:"dl qr-code"},[_c('dt',[_vm._v("关注耀莱在线")]),_vm._v(" "),_c('dd',[_c('sr-qr-code',{attrs:{"text":_vm.qrCodeSR,"size":_vm.qrCodeSize}})],1)]),_vm._v(" "),_c('dl',{staticClass:"dl qr-code"},[_c('dt',[_vm._v("商家入驻")]),_vm._v(" "),_c('dd',[_c('sr-qr-code',{attrs:{"text":_vm.qrCodeBusiness,"size":_vm.qrCodeSize}})],1)])]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"dl address"},[_c('dt',[_vm._v("联系我们")]),_vm._v(" "),_c('dd',[_vm._v("\n          400-118-0970（09：00 a.m -- 19：00 p.m）"),_c('br'),_vm._v("\n          contact@ylzxvip.com"),_c('br'),_vm._v("\n          北京市-朝阳区-三里屯-新东路40号耀莱中心"),_c('br'),_vm._v("\n          北京新耀莱网络科技有限公司"),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_vm._v("\n\n      © 2019-2020 北京新耀莱网络科技有限公司版权所有 ICP证："),_c('a',{staticStyle:{"text-decoration":"none","color":"#fff"},attrs:{"href":"http://www.beian.miit.gov.cn"}},[_vm._v("京ICP备19022411号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uUni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("9qt5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_c5a3e70a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("YLOT");
function injectStyle (ssrContext) {
  __webpack_require__("TOte")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c5a3e70a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_c5a3e70a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wTL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sr-property"},[_c('div',{staticClass:"gallery"},[_c('sr-thumb-zoom',{attrs:{"list":_vm.DATA.img,"path":true}})],1),_vm._v(" "),_c('div',{staticClass:"wrap"},[_c('p',{staticClass:"brand"},[_vm._v(_vm._s(_vm.DATA.brandNameEn)+" / "+_vm._s(_vm.DATA.brandName))]),_vm._v(" "),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.DATA.name))]),_vm._v(" "),_c('p',{staticClass:"productTitle"},[_vm._v(_vm._s(_vm.DATA.productTitle))]),_vm._v(" "),_c('p',{staticClass:"basicPrice"},[_vm._v("市场价："+_vm._s(_vm._f("money")(_vm.DATA.basicPrice)))]),_vm._v(" "),_c('p',{staticClass:"currentPrice"},[_vm._v("耀莱在线价格："),_c('span',[_vm._v(_vm._s(_vm._f("money")(_vm.DATA.currentPrice)))])]),_vm._v(" "),_c('p',{staticClass:"calculateCoinByProduct"},[_vm._v("购物即赠送 "+_vm._s(_vm._f("money")(_vm.DATA.calculateCoinByProduct))+" 金币")]),_vm._v(" "),(_vm.DATA.reminde)?_c('p',{staticClass:"reminder"},[_vm._v("温馨提示："+_vm._s(_vm.DATA.reminder))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"buy",on:{"click":function($event){return _vm.buy(_vm.DATA.uuid)}}},[_vm._v("立即购买")])]),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"300px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"dialog-con"},[_c('p',[_vm._v("微信扫一扫，立即购买")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.DATA.name))]),_vm._v(" "),_c('sr-qr-code',{attrs:{"text":_vm.qrCodeText}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xU/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("nhZ1");


/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    // 价格
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('money', function (value) {
      if (!value) {
        return '¥0.00'; // ￥
      } else {
        return '¥' + Math.abs(parseFloat(value)).toFixed(2);
      }
    });
  }
});

/***/ }),

/***/ "ydHY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: Object
  },
  data: function data() {
    return {
      DATA: this.data
    };
  }
});

/***/ }),

/***/ "yt9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loading__ = __webpack_require__("qERK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_list__ = __webpack_require__("hXc6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_list_item__ = __webpack_require__("b/+Y");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SrLoading: __WEBPACK_IMPORTED_MODULE_1__components_loading__["a" /* default */],
    srList: __WEBPACK_IMPORTED_MODULE_2__components_list__["a" /* default */],
    srListItem: __WEBPACK_IMPORTED_MODULE_3__components_list_item__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      tabData: [{
        label: 1,
        text: '最新上市'
      }, {
        label: 4,
        text: '价格由高到低'
      }, {
        label: 3,
        text: '价格由底到高'
      }],
      listData: [],
      queryForm: {
        pageNum: 1,
        pageSize: 20,
        productType: 1, // 1为奢侈品列表 3为餐券列表 （默认为奢侈品列表）
        baseType: 1 // 1 按时间顺序 2 按时间倒序 3 按价格正序 4按价格倒序 5 按促销折扣从大到小 6按促销折扣从小到大 7 按库存顺序 8按库存倒序 9按销量顺序 10按销量倒序
      },
      total: 0
    };
  },

  methods: {
    go: function go(v) {
      this.$router.push({
        path: '/list-detail/' + v
      });
    },
    goTop: function goTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    tabChange: function tabChange(v) {
      this.queryForm.pageNum = 1;
      this.queryForm.baseType = v;
      this.selectProductSpuList();
    },
    handleSizeChange: function handleSizeChange(v) {
      this.queryForm.pageSize = v;
      this.selectProductSpuList();
    },
    handleCurrentChange: function handleCurrentChange(v) {
      this.goTop();
      this.queryForm.pageNum = v;
      this.selectProductSpuList();
    },
    selectProductSpuList: function selectProductSpuList() {
      var _this = this;

      this.loading = true;
      var id = this.$route.query.id;
      var type = this.$route.params.type;
      if (type === 'category') {
        this.$set(this.queryForm, 'entityIds', id);
        this.$delete(this.queryForm, 'brandId', id);
      } else if (type === 'brand') {
        this.$delete(this.queryForm, 'entityIds', id);
        this.$set(this.queryForm, 'brandId', id);
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/productSpuController/selectProductSpuList', {
        params: this.queryForm
      }).then(function (res) {
        if (res.data.code === 9999) {
          _this.listData = res.data.data.list;
          _this.total = res.data.data.total;
          _this.loading = false;
        }
      });
    }
  },
  created: function created() {
    this.selectProductSpuList();
  },

  watch: {
    '$route': function $route(v) {
      this.goTop();
      this.queryForm.baseType = 1;
      this.queryForm.pageNum = 1;
      this.selectProductSpuList();
    }
  }
});

/***/ }),

/***/ "z5L2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zS9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sr_param_vue__ = __webpack_require__("ydHY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2a7decc0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sr_param_vue__ = __webpack_require__("5k0U");
function injectStyle (ssrContext) {
  __webpack_require__("i6xC")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a7decc0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sr_param_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2a7decc0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sr_param_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3564c96cf47f2cdc2224.js